import React from 'react'

interface ModalClickBoundaryProps {
  children: React.ReactNode
}

// A modal opened from inside a Semantic UI <Dropdown.Menu> portals its DOM to
// document.body, but React synthetic clicks still bubble through the portal
// tree back to the Dropdown and re-open the menu behind the modal. Wrap the
// modal in this boundary to contain every in-modal click at the modal root, so
// clicking neutral space (header, body copy, labels, padding) no longer
// re-opens the menu. The focus-return re-open is separate — set
// openOnFocus={false} on the Dropdown.
export default function ModalClickBoundary({ children }: ModalClickBoundaryProps) {
  return <span onClick={(e) => e.stopPropagation()}>{children}</span>
}



// WEBPACK FOOTER //
// ./src/shared/components/ModalClickBoundary/index.tsx